var _path, _text, _text2, _text3, _style;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProductBuilderTemplate11OzMug(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 2674,
    height: 1114,
    fill: "none",
    viewBox: "0 0 2674 1114",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    stroke: "#0080FF",
    strokeDasharray: "6 6",
    strokeWidth: 1,
    d: "M600.93 0v1114M1338 0v1114M2071.19 0v1114"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 450,
    y: 1080
  }, "Middle of face")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 1160,
    y: 1080
  }, "Opposite handle")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 1925,
    y: 1080
  }, "Middle of face")), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\r\n    text {\r\n      font-family:sans-serif;\r\n      fill: black;\r\n      font-size: 50px;\r\n      paint-order: stroke;\r\n      stroke: #fff;\r\n      stroke-width: 20px;\r\n      stroke-linecap: butt;\r\n      stroke-linejoin: round;\r\n      opacity: .66;\r\n      text-align: center;\r\n    }\r\n  ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductBuilderTemplate11OzMug);
export default __webpack_public_path__ + "static/media/product-builder-template_11oz-mug.cfc9df74acc2520e8a6924b92b1c0e2e.svg";
export { ForwardRef as ReactComponent };